module.exports = __webpack_public_path__ + "static/media/PopMatch.a742d5fd.png";